import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`At the request of the Geological Survey of Botswana I have retrieved a selection
of 35 mm slides  from my archives to tell the story of how regional geophysical
surveys got started in the Kalahari.  The work began with geophysical studies in
the Okavango delta (gravity, seismic refraction and  micro-seismicity) and later
extended into a national gravity survey and aeromagnetic  reconnaissance of the
sand-covered regions. The slide collection may be viewed at the web-album
address `}<a parentName="p" {...{
        "href": "/reevesdotnl/"
      }}>{`here`}</a>{`.`}</p>
    <p>{`A short descriptive text appears below. `}</p>
    <h1>{`Some notes on my time in Botswana, 1970-74`}</h1>
    <p>{`I arrived in Lobatse late in the evening of January 1, 1970 at the end of a 34
hour train journey  from Cape Town that had followed a 10-day ocean voyage from
Southampton, England. I think  that that was the hottest day I ever experienced
in Botswana! I was met from the train by Chris  Jennings and, complete with all
my luggage, taken to the Cumberland Hotel. This was to be my  home for many
weeks as my entitlement to government housing took some time to fulfill. `}</p>
    <p>{`De Beers were busy starting the development of the Orapa diamond mine at this
time and  enhancing the supply of surface water to the mine through accelerating
the flow of the Boro River  in the Okavango Delta in order to fill the Mopipi
Pan near the mine (via the Boteti River) was the  strategy of the time. The
Geological Survey felt it needed to know more about the Okavango Delta  and sent
me to Maun after a few weeks to undertake some gravity traverses across the
fault lines  that marked the SE edge of the delta. Mr ‘Burgy’ Burgoffer, GS
diamond driller, was already in the  area and met me at Maun airfield. I had
never flown before! I stayed at Riley’s Hotel – my first  experience of a
colonial-style hotel in Africa. `}</p>
    <p>{`A few days of fieldwork showed interesting anomalies across the fault lines and
I was sent back  with a full field support camp to do more work on April 1 that
year, very shortly after I had finally  acquired a permanent place to live in
Lobatse, in the flats opposite the Geological Survey. This  field effort finally
extended across the whole six month season until October 1970. I was  constantly
concerned that the work would be cut short by other priorities and I became
utterly  exhausted after months of field living and many kilometers of travel on
primitive tracks. The time  was also filled with new experiences of African
wildlife, the limited facilities of Maun for  replenishing stores and the
fascinating flooding around Maun in June and July as the floodwaters  from
Angola brought these rivers to life at the height of the dry season. I travelled
extensively to  the NE and SW along the base of the delta and executed whatever
traverses could be made at  right angles to the strike of the fault lines. An
early excursion was along the length of Chief’s  Island, before it became
inaccessible with the rise of the annual flood waters. Sleepless nights,
concerned about the possible appearance of lions in camp, contributed to the
excitement. `}</p>
    <p>{`Prior to my time in Lobatse, geophysics in the GS had been confined to local
studies for  groundwater and mineral exploration. I had the feeling that this
would never grow into the  contribution regional geophysics could make to
exploring the solid geology hidden below the three quarters of Botswana that
were covered by the Kalahari Sand. Pursuing this possibility with gravity  and
aeromagnetic surveys eventually initiated many years of systematic geophysical
mapping  efforts in Botswana, most of it by air. `}</p>
    <p>{`Back in Lobatse, October 1970 brought the traditional summer season of
unpredictable rain and  geologists in the office writing up their field results.
Settling in again revealed the desperate  shortage of professional staff and the
imminent return to England of several long-serving  geological mapping officers
like John Bennett and Dick Crockett . GS Director Colin Boocock – already on
staff in Lobatse for, I think, 22 years – also announced his intention to resign
and move  back to South Africa. For a time there was just myself and a few other
junior staff members all  told! Nevertheless, the Okavango gravity work was
considered of high importance and I was sent  back for a second, much shorter,
field season in August-September 1971. This time I had the  support of technical
assistant Frank Bicheno and the programme was to include some more  ambitious
traverses – by small open boat into the delta itself (courtesy of UNDP) and
around the  north and west of the delta. This work was eventually written up as
GS Bulletin 11 – The Gravity  Survey of Ngamiland, 1970-71 `}<strong parentName="p">{`[2]`}</strong>{`. `}</p>
    <p>{`At the end of the 1971 field season, my return to Lobatse coincided with the
arrival of a whole new  cohort of professional staff from the UK, led by John
Hepworth as the new Director. This quickly led to a new lease of life for many
GS activities and geophysical reconnaissance was no exception,  now supported by
a second geophysicist, Dave Hutchins, who was to contribute to the GS for  many
years to come. The gravity work in Ngamiland was expanded to the idea of
executing a  gravity survey of the whole country – the National Gravity Survey
or ‘Natgrav’. This was carried  out between August 1972 and December 1973 with
financial support from the UK Government.  The work was made up of three phases,
not necessarily in this order: (1) A network of national  base stations was
needed and 23 points were established by flying two Lacoste and Romberg
gravimeters between these points and international base stations in Johannesburg
and  Livingstone, Zambia. This took two weeks flying with Cessna aircraft Zulu
Golf Charlie. (2) Then  there were the routine ground observations along all
motorable tracks at 10 km intervals – at an  average of about 8 new stations day
to a total of about 2500 points. This was the bulk of the work  and took 18
months and 45 000 km of driving. (3) Finally, the least accessible areas of the
Central  Kalahari and the SW corner of the country were filled in by helicopter
transport `}<strong parentName="p">{`[3]`}</strong>{`. In all these  operations, position-fixing was the most demanding
aspect. A primitive magnetic land navigator  was used on the main survey
Land-Rover and some of the earliest satellite imagery (Landsat 1) was also
pressed into service. The efficiency of helicopter operations convinced me that
‘airborne’  was the only way ahead for geophysical reconnaissance programmes in
the future. `}</p>
    <p>{`Support for these efforts came from the British Geological Survey, or the
Institute of Geological  Sciences as it was then called. Richard Carruthers
assisted with the gravity base station network  and he was joined by Peter
Greenwood to execute a seismic refraction survey in the Okavango  delta to
follow up the result of the gravity survey `}<strong parentName="p">{`[1]`}</strong>{`. ‘Okaseis’ was carried out in
1973-4 at the  height of the hot season. Getting explosives to Maun was a major
part of that task! Huge charges  had to be used because the Kalahari Sand proved
very absorbent of seismic energy. After I left  Botswana, Chris Scholz did
further work investigating the seismicity of the Okavango Delta `}<strong parentName="p">{`[4]`}</strong>{`. `}</p>
    <p>{`By the start of 1974, the end of my second contract in Lobatse was in sight and
I was luckily able  to pursue the completion of the National Gravity Survey as
part of a PhD study at the University of  Leeds where they still had an
Institute of African Geology. Remember, there were no suitable  computer
facilities in Lobatse at that time. That work kept me busy until October 1976,
two years  after I stopped living in Lobatse. Bulletin 5 – The National Gravity
Survey of Botswana – was part  of that output `}<strong parentName="p">{`[3]`}</strong>{`. `}</p>
    <p>{`John Hepworth had also been successful in interesting the Canadians in helping
with an airborne  magnetic reconnaissance of the Kalahari and Norm Paterson came
on a visit to advise on the  specifications for such an exercise early in 1974.
This ‘CIDA’ survey was carried out in 1975-6,  some 18 months after I left but,
by the time I had finished my PhD, I had been offered a job with  Geoterrex in
Ottawa and found myself working on the compilation of that Botswana aeromagnetic
survey and its publication. Eventually Geoterrex also got the job of
interpreting these results and I  worked on that in Ottawa, with help from Dave
Hutchins (who had taken over my role as leading  geophysicst in Lobatse), from
about September 1977 until mid 1978. The report that emerged  became something
of a milestone in the exploration of Botswana’s geology and has been reprinted
several times `}<strong parentName="p">{`[5]`}</strong>{`. `}</p>
    <p>{`For me, my long involvement with Botswana ended in 1978 when I left Geoterrex
and joined  Paterson Grant and Watson in Toronto and moved on to parallel
problems of using geophysics to  map hidden geology in many other parts of the
world. This has included a great deal of work in  other parts of Africa as well
as in India, Australia and elsewhere. But the lessons learned in  Botswana have
lasted a whole lifetime of professional activity. And Botswana still sets an
excellent  example of what could be achieved in many places where the geology
does not lend itself to  mapping by the traditional methods of field geology. `}</p>
    <p><strong parentName="p">{`Colin Reeves`}</strong></p>
    <PublishDate prepend="Delft, " mdxType="PublishDate" />
    <p><strong parentName="p">{`Further reading`}</strong></p>
    <p><strong parentName="p">{`[1]`}{` Greenwood, P.G. and Carruthers, R., 1973.`}</strong>{` Geophysical Surveys in the
Okavango Delta,  Botswana. Report No. 15, Institute of Geological Sciences,
Geophysical Division, London.`}</p>
    <p><strong parentName="p">{`[2]`}{` Reeves, C.V., 1978.`}</strong>{` The Gravity Survey of
Ngamiland, 1970-71. Bulletin No. 11, Geological  Survey of Botswana, Lobatse. 78
p + appendices and maps. `}</p>
    <p><strong parentName="p">{`[3]`}{` Reeves, C.V. and Hutchins, D.G., 1976.`}</strong>{` The National Gravity Survey of
Botswana, 1972-3.  Bulletin No.5, Geological Survey of Botswana, Lobatse. 36 p +
appendices and maps.`}</p>
    <p><strong parentName="p">{`[4]`}{` Scholz, C., 1998.`}</strong>{` Fieldwork: A Geologist's Memoir of
the Kalahari. Princeton University Press,  198 p.`}</p>
    <p><strong parentName="p">{`[5]`}{` Terra Surveys Limited, 1978.`}</strong>{` Reconnaissance Aeromagnetic Survey of
Botswana, 1975-7.  Botswana Geological Survey Department and Canadian
International Development Agency. 199 p  + appendices and maps.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      